var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgSearchBulb(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 5.5a8 8 0 11-5.174 14.102l-6.238 6.237-.707-.707 6.224-6.224A8 8 0 0117.5 5.5zm0 1a7 7 0 100 14 7 7 0 000-14zm1.313 9.02v.89a.894.894 0 01-.73.87l-.108.017-.062.002h-1.066a.899.899 0 01-.881-.719l-.017-.108-.002-.062v-.89h2.866zM17.38 9.7c1.377 0 2.5 1.093 2.5 2.448a2.41 2.41 0 01-.661 1.655l-.139.136v.287a.886.886 0 01-.535.81l-.112.041-.108.027-.083.01-.062.002h-1.6a.9.9 0 01-.88-.72l-.018-.108-.002-.062v-.287l-.092-.085a2.43 2.43 0 01-.641-1.148l-.038-.188-.023-.193-.005-.093-.001-.084c0-1.355 1.122-2.448 2.5-2.448zm0 1c-.782 0-1.42.577-1.493 1.301l-.007.137.004.12c.028.36.195.694.452.932l.12.098.224.148-.001.679 1.401.001v-.66l.252-.19c.347-.276.548-.683.548-1.118 0-.796-.669-1.448-1.5-1.448z"
  }));
}

export default SvgSearchBulb;